//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  const INFO_ALERTS_CLASS = 'info-alerts-active';
  const content = angular.module('curalate');

  content.component('infoAlerts', {
    template:
      '<div class="info-alerts-bar cu-pos-fixed cu-text-center cu-text-white cu-valign-children-middle">' +
      '<span>{{$ctrl.model.message}}' +
      ' <a ng-if="$ctrl.model.linkText && $ctrl.model.linkTarget" ng-click="$ctrl.recordLinkClick()" ' +
      'class="cu-alert-link" href="{{$ctrl.model.linkTarget}}" target="_blank">{{$ctrl.model.linkText}}</a>' +
      '</span>' +
      '<a href="#" class="dismiss-alert cu-mt-1 cu-mr-3" ng-click="$ctrl.dismiss()">' +
      '<cu-icon class="cu-align-self-end" name="close-lg"></cu-icon>' +
      '</a>' +
      '</div>',
    controller: [
      '$document',
      'SystemAlertsService',
      'TrackingService',
      function ($document, SystemAlertsService, TrackingService) {
        this.active = false;
        this.model = {};

        this.updateActive = function (newVal) {
          const oldVal = this.active;
          this.active = newVal;

          if (newVal && !oldVal) {
            $document[0].body.classList.add(INFO_ALERTS_CLASS);
          } else if (!newVal && oldVal) {
            $document[0].body.classList.remove(INFO_ALERTS_CLASS);
          }
        };

        this.$onInit = function () {
          const self = this;
          // For now, only one Alert can occur per page load.
          SystemAlertsService.getInfoAlerts().then((alerts) => {
            if (alerts.length > 0) {
              self.model = alerts[0];
              self.updateActive(true);
              recordView(self.model);
            }
          });
        };

        this.dismiss = function () {
          this.model.dismiss();
          this.updateActive(false);

          TrackingService.recordEvent(
            TrackingService.CATEGORY_INFO_ALERT,
            getAppropriateTrackingAction(this.model, 'DISMISS'),
          );
        };

        this.recordLinkClick = function () {
          TrackingService.recordEvent(
            TrackingService.CATEGORY_INFO_ALERT,
            getAppropriateTrackingAction(this.model, 'LINKOUT'),
          );
        };

        this.$onDestroy = function () {
          this.updateActive(false);
        };

        function getAppropriateTrackingAction(alert, action) {
          return `${alert.trackingId}_${action}`;
        }

        function recordView(alert) {
          const viewCount = alert.incrementViewCount();
          const viewAction = viewCount > 1 ? 'SUBSEQUENT_VIEW' : 'FIRST_VIEW';
          TrackingService.recordEvent(
            TrackingService.CATEGORY_INFO_ALERT,
            getAppropriateTrackingAction(alert, viewAction),
            undefined,
            viewCount,
          );
        }
      },
    ],
  });
})();
